import BarChartSection from '@/pages/Statistics/BarChartSection';
import { StatisticsProvider } from '@/pages/Statistics/StatiscticsContext';
import { DashboardCard } from '../card';

interface Props {
  isDashboard?: boolean;
}

const AmountInfo = ({ isDashboard }: Props) => {
  return (
    <DashboardCard className="p-1">
      <StatisticsProvider>
        <BarChartSection isDashboard={isDashboard} />
      </StatisticsProvider>
    </DashboardCard>
  );
};

export default AmountInfo;
